import { render, staticRenderFns } from "./SupplementaryIconOld.vue?vue&type=template&id=9ed182c6&scoped=true"
import script from "./SupplementaryIconOld.vue?vue&type=script&lang=js"
export * from "./SupplementaryIconOld.vue?vue&type=script&lang=js"
import style0 from "./SupplementaryIconOld.vue?vue&type=style&index=0&id=9ed182c6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ed182c6",
  null
  
)

export default component.exports